/**
 * RootLayout component that serves as the main layout for the application.
 * It conditionally renders the NavBar component based on the current route.
 * This component uses the `useLocation` hook from `react-router-dom` to determine the current route.
 * If the current route is either "/login" or "/signup", the NavBar component will not be rendered.
 * Otherwise, the NavBar component will be displayed.
 *
 * The main content of the layout is wrapped in a `main` element with a CSS class from the `Root.module.scss` file.
 * The `Outlet` component from `react-router-dom` is used to render the matched child route components.
 */
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./Navbar.tsx";
import StandardFooter from "../Footer/StandardFooter.tsx";
import NewsfeedFooter from "../Footer/NewsfeedFooter.tsx";
import classes from "./Root.module.scss";

const RootLayout = () => {
    const location = useLocation();
    const hideNavBarRoutes = ["/login", "/signup", "/auth", "/profile-setup", "/launching-soon"];
    const hideFooterRoutes = [...hideNavBarRoutes];

    // Determine which footer to show based on the route
    const isNewsfeedRoute = location.pathname.startsWith("/newsfeed");

    // Check if the current route matches any in the array (including nested routes)
    // console.log("location.pathname");
    console.log(location.pathname);
    const shouldHideNavBar = hideNavBarRoutes.some(
        (route) => location.pathname.startsWith(route) || location.pathname === route,
    );
    const shouldHideFooter = hideFooterRoutes.some(
        (route) => location.pathname.startsWith(route) || location.pathname === route,
    );

    return (
        <>
            {!shouldHideNavBar && <NavBar />}
            <main className={shouldHideNavBar ? "" : classes.mainContainer}>
                <Outlet />
            </main>
            {/* Only show footer at the bottom for non-newsfeed routes */}
            {!shouldHideFooter && !isNewsfeedRoute && <StandardFooter />}
        </>
    );
};

export default RootLayout;
